import React, { useEffect, useState } from 'react';
import {
    Box, Grid, Paper, Typography, CircularProgress,
    Card, CardContent, Divider
} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { formatDate } from '../../../utils/helpers';
import adminService from '../../../services/adminService';

const StatCard = ({ title, value, icon, color }) => (
    <Card sx={{ height: '100%', bgcolor: '#1e293b', color: 'white', border: '1px solid rgba(255,255,255,0.1)' }}>
        <CardContent>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                    <Typography color="#94a3b8" gutterBottom variant="overline">
                        {title}
                    </Typography>
                    <Typography variant="h4" fontWeight="bold">
                        {value}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        width: 48,
                        height: 48,
                        bgcolor: `${color}.main`,
                        color: 'white',
                        borderRadius: '50%', // Circle looks better for these stats
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: `0 0 15px ${color}.main`,
                        flexShrink: 0
                    }}
                >
                    {React.cloneElement(icon, { sx: { fontSize: 26 } })}
                </Box>
            </Box>
        </CardContent>
    </Card>
);

const AdminDashboard = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const res = await adminService.getDashboardStats();
            if (res.success) {
                setStats(res.data);
            }
        } catch (error) {
            console.error('Failed to fetch stats', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <Box p={4} textAlign="center"><CircularProgress /></Box>;

    return (
        <Box p={3}>
            <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ color: '#f1f5f9' }}>
                Tổng Quan
            </Typography>
            <Typography color="#94a3b8" mb={4}>
                Chào mừng quản trị viên quay trở lại.
            </Typography>

            {/* Stats Cards */}
            <Grid container spacing={3} mb={4}>
                <Grid item xs={12} sm={4}>
                    <StatCard
                        title="TỔNG THÀNH VIÊN"
                        value={stats?.totalUsers || 0}
                        icon={<PeopleIcon />}
                        color="primary"
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <StatCard
                        title="DOANH THU (VND)"
                        value={Number(stats?.totalRevenue || 0).toLocaleString()}
                        icon={<MonetizationOnIcon />}
                        color="success"
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <StatCard
                        title="ĐƠN HÀNG GẦN ĐÂY"
                        value={stats?.recentOrders?.length || 0}
                        icon={<ShoppingCartIcon />}
                        color="warning"
                    />
                </Grid>
            </Grid>

            <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />

            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ color: '#f1f5f9' }}>
                Đơn Hàng Mới Nhất
            </Typography>
            <Paper sx={{ width: '100%', overflow: 'hidden', bgcolor: '#1e293b', color: 'white', border: '1px solid rgba(255,255,255,0.1)' }}>
                {/* Simple Table could go here, or we reuse DataGrid later */}
                {stats?.recentOrders?.length > 0 ? (
                    stats.recentOrders.map(order => (
                        <Box key={order.id} p={2} borderBottom="1px solid rgba(255,255,255,0.05)" display="flex" justifyContent="space-between">
                            <Box>
                                <Typography fontWeight="bold">
                                    {order.user?.username || 'Unknown User'}
                                </Typography>
                                <Typography variant="body2" color="#94a3b8">
                                    {order.servicePackage?.name || order.snapshotName}
                                </Typography>
                            </Box>
                            <Box textAlign="right">
                                <Typography fontWeight="bold" color="#4ade80">
                                    +{Number(order.finalAmount).toLocaleString()} đ
                                </Typography>
                                <Typography variant="caption" color="#94a3b8">
                                    {formatDate(order.createdAt, 'dd/MM/yyyy HH:mm:ss')}
                                </Typography>
                            </Box>
                        </Box>
                    ))
                ) : (
                    <Box p={2}>Chưa có đơn hàng nào.</Box>
                )}
            </Paper>
        </Box>
    );
};

export default AdminDashboard;
